<template>

  <div class="h-screen flex w-full
        bg-img vx-row no-gutter
        justify-center padding_change_password"
       id="page-init-password"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body">
          <div>
            <div class="no-gutter justify-start  border-radius-default">
              <div class="vx-row no-gutter justify-center items-center p-4 login-tabs-container">
                <div class="vx-col sm:w-full md:w-full lg:w-full d-theme-dark-bg ">
                  <div class="grid">
                    <vs-row class="mt-1 mb-5 p-3 background_color_card border-radius-default">
                      <strong>新しいパスワードを入力して、登録ボタンをクリックしてください。</strong>
                    </vs-row>
                  </div>
                  <div class="grid p-3 background_color_card border-radius-default">
                    <vs-row class="mt-5 mb-3">
                      <vs-col vs-type="flex" vs-align="center" vs-w="4">
                        <label for="current-password">現在のパスワード<span class="color_red">*</span></label>
                      </vs-col>
                      <vs-col vs-type="flex" vs-align="center" vs-w="8">
                        <vs-input id="current-password"
                                  name="current_password"
                                  class="inputx w-full"
                                  :type="show_password ? 'text' : 'password'"
                                  placeholder=""
                                  v-model="current_password"
                                  />
                      </vs-col>
                    </vs-row>
                    <vs-row>
                      <vs-col vs-w="8" vs-offset="4">
                        <span style="color: red">{{ messageError.current_password }}</span>
                      </vs-col>
                    </vs-row>
                    <vs-row class="mt-5 mb-3">
                      <vs-col vs-type="flex" vs-align="center" vs-w="4">
                        <label for="password">新しいパスワード <span class="color_red">*</span></label>
                      </vs-col>
                      <vs-col vs-type="flex" vs-align="center" vs-w="8">
                        <vs-input id="password"
                                  name="password"
                                  class="inputx w-full"
                                  :type="show_password ? 'text' : 'password'"
                                  placeholder=""
                                  v-model="password"/>
                      </vs-col>
                    </vs-row>
                    <vs-row>
                      <vs-col vs-w="8" vs-offset="4">
                        <span style="color: red">{{ messageError.password }}</span>
                      </vs-col>
                    </vs-row>
                    <vs-row class="mt-5 mb-3">
                      <vs-col vs-type="flex" vs-align="center" vs-w="4">
                        <label for="password-confirm">新しいパスワード（再入力）<span class="color_red">*</span></label>
                      </vs-col>
                      <vs-col vs-type="flex" vs-align="center" vs-w="8">
                        <vs-input id="password-confirm"
                                  name="password_confirm"
                                  class="inputx w-full"
                                  :type="show_password ? 'text' : 'password'"
                                  placeholder=""
                                  v-model="password_confirm"
                                  />
                      </vs-col>
                    </vs-row>
                    <vs-row>
                      <vs-col vs-w="8" vs-offset="4">
                        <span style="color: red">{{ messageError.confirm_password }}</span>
                        
                      </vs-col>
                    </vs-row>
                    <vs-row>
                      <vs-col vs-w="8" vs-offset="4">
                        <vs-checkbox v-model="show_password" @click="togglePassword">パスワードを表示</vs-checkbox>
                      </vs-col>
                    </vs-row>
                  </div>
                  <div class="grid">
                    <vs-row class="mt-2" vs-justify="space-between">
                      <vs-col vs-type="flex" 
                              vs-justify="flex-end">
                        <vs-button color="success" icon="assignment" @click="submitRequest">登録 </vs-button>
                      </vs-col>
                      
                    </vs-row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      password: '',
      messageError: {
        'current_password': '',
        'password': '',
        'confirm_password': ''
      },
      password_confirm: '',
      current_password: '',
      regexFullWidth: /[ぁ-んァ-ン一-龥]/,
      regexTwoByteNumber: /[\uff10-\uff19\uff21-\uff3a\uff41-\uff5a]/,
      show_password: false,
    }
  },
  methods: {
    ...mapActions({
      changePassword: 'passwordModule/changePassword'
    }),

    async submitRequest() {
      
      let validateSuccess = this.validateHandleSubmit();
      if (validateSuccess) {
        let params = {
          password: this.password,
          password_confirmation: this.password_confirm,
          current_password: this.current_password
        };
        const response = await this.changePassword(params);
        // if (response.status) {
        //   this.resetForm()
        // }
      }

      // console.log(response)
    },
    
    validateHandleSubmit() {
      let resultValidate = 0;
      if (this.validateCurrentPassword()) {
        resultValidate++
      }
      if (this.validatePassword()) {
        resultValidate++
      }
      if (this.validateConfirmPassword()) {
        resultValidate++
      }
      
      if (resultValidate > 0) {
        return false
      } else {
        return true
      }
    },

    resetForm() {
      this.password = ''
      this.password_confirm = ''
    },
    togglePassword() {
      this.show_password = !this.show_password;
    },
    validateInput() {
      this.$validator.validateAll()
    },
    validateCurrentPassword () {
      let resultValidate = true
      if (this.current_password.length < 1) {
        this.messageError.current_password = '現在のパスワードは必須です。'
      } else if (this.regexFullWidth.test(this.current_password)) {
        this.messageError.current_password = '全角文字で入力できません。'
      } else if (this.regexTwoByteNumber.test(this.current_password)) {
        this.messageError.current_password = '全角文字で入力できません。'
      } else {
        resultValidate = false
        this.messageError.current_password = ''
      }
      return resultValidate
    },
    validatePassword () {
      console.log(this.regexFullWidth.test(this.password))
      let resultValidate = true
      if (this.password.length < 1) {
        this.messageError.password = 'パスワードは必須です。'
      } else if (this.password.length < 6) {
        this.messageError.password = 'パスワードは6文字以上で指定してください。'
      } else if (this.regexFullWidth.test(this.password)) {
        this.messageError.password = '全角文字で入力できません。'
      } else if (this.regexTwoByteNumber.test(this.password)) {
        this.messageError.password = '全角文字で入力できません。'
      }else {
        resultValidate = false
        this.messageError.password = ''
      }
      if (this.password == this.password_confirm) {
        this.messageError.confirm_password = ''
      }
      return resultValidate
    },
    validateConfirmPassword () {
      let resultValidate = true
      if (this.password_confirm.length < 1) {
        this.messageError.confirm_password = '確認パスワードは必須です。'
      } else if (this.password_confirm != this.password) {
        this.messageError.confirm_password = '確認パスワードとパスワードが一致していません。'
      } else if (this.password_confirm.length < 6) {
        this.messageError.confirm_password = '確認パスワードは6文字以上で指定してください'
      } else if (this.regexFullWidth.test(this.password_confirm)) {
        this.messageError.confirm_password = '全角文字で入力できません。'
      } else if (this.regexTwoByteNumber.test(this.password_confirm)) {
        this.messageError.confirm_password = '全角文字で入力できません。'
      } else {
        resultValidate = false
        this.messageError.confirm_password = ''
      }
      return resultValidate
    }
  },
  watch: {
    current_password () {
      this.validateCurrentPassword()
    },
    password () {
      this.validatePassword()
    },
    password_confirm () {
      this.validateConfirmPassword()
    }
  }
};
</script>

<style scoped>
.padding_change_password {
  padding-top: 7%;
}
</style>